module.exports = __webpack_public_path__ + "img/page-device-order-list-qrcode-car.e930c028.png";